<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left"></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/global/logo.png"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>
    <img class="full-image" src='../../assets/img/other/survey.png'>
      <div class="question3"></div>
    <div class="survey-title">请问您是从哪里知道到家的 ？</div>
    <div class="weui-cells weui-cells_checkbox">
        <label class="weui-cell weui-check__label" for="s1">
            <div class="weui-cell__hd">
                <input type="radio" name="step1" class="weui-check" id="s1" value="1575091600"  v-model="survey">
                <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
                <p>朋友推荐</p>
            </div>
        </label>

        <label class="weui-cell weui-check__label" for="s2">
            <div class="weui-cell__hd">
                <input type="radio" class="weui-check" name="step1" id="s2" value="1575091614" v-model="survey">
                <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
                <p>今日澳洲 / 今日悉尼</p>
            </div>
        </label>

        <label class="weui-cell weui-check__label" for="s3">
            <div class="weui-cell__hd">
                <input type="radio" name="step1" class="weui-check" id="s3" value="1575091623"  v-model="survey">
                <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
                <p>看TV / 看看澳洲</p>
            </div>
        </label>
        <label class="weui-cell weui-check__label" for="s4">
            <div class="weui-cell__hd">
                <input type="radio" name="step1" class="weui-check" id="s4" value="1575091659"  v-model="survey">
                <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
                <p>微信公众号宣传</p>
            </div>
        </label>
        <label class="weui-cell weui-check__label" for="s5">
            <div class="weui-cell__hd">
                <input type="radio" name="step1" class="weui-check" id="s5" value="1575091634"  v-model="survey">
                <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
                <p>网络搜索引擎</p>
            </div>
        </label>
        <label class="weui-cell weui-check__label" for="s6">
            <div class="weui-cell__hd">
                <input type="radio" name="step1" class="weui-check" id="s6" value="1575091648"  v-model="survey">
                <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
                <p>我是老用户 </p>
            </div>
        </label>
        <label class="weui-cell weui-check__label" for="s7">
            <div class="weui-cell__hd">
                <input type="radio" name="step1" class="weui-check" id="s7" value="1575091669"  v-model="survey">
                <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
                <p>其他渠道 </p>
            </div>
        </label>
      </div>
      <div class="js_dialog" v-show="success">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">谢谢您的反馈！</strong></div>
              <div class="weui-dialog__bd">感谢使用到家，祝您生活愉快</div>
              <div class="weui-dialog__ft">
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="$router.push('/order');">好的</div>
              </div>
          </div>
      </div>
      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在发送数据</p>
              </div>
          </div>
      </transition>
  </div>
</template>

<script>
import anime from 'animejs';
import qs from 'qs'

export default {
  name: 'survey',
  data () {
    return {
      survey:0,
      success:false,
      isSending:false,
    }
  },
  methods: {
    submit(){
      if(this.isSending || this.survey==0){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;
        let svResult = {};
        svResult.order_id = localStorage.surveyID;
        svResult.userSrc = that.survey;
        svResult.token = localStorage.token;
        this.axios.post(this.apiURL()+'/Marketing/userSrc', qs.stringify(svResult))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending=false;
            that.success = true;
            localStorage.removeItem('surveyID');
          }
          else{
            that.survey = 0;
            that.isSending=false;
            alert("提交失败："+response.data.data)
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
        });
      }
    },
  },

  watch: {
    survey: function (val) {
      this.submit();
    },
  },
  components: {
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:50px;
  padding-bottom:100px;
}

.title{
  font-size:1.8em;
  margin-bottom:12px;
}
.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:2vh;
  width:100vw;
  box-sizing:border-box;
  color:#999;
  a{
    color:#fe9567;
  }
}
.image-box{
  img{
    width:100%;
  }
  font-size:0;
}
.btn{
  margin-top:20px;
}
.text{
  text-align:center;
  font-size:1.2em;
  color:#888;
}

.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:34px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}

.btn-box-fix .btn.active{
  margin-left:0;
  margin-top:0;
}

.clean-services{
  text-align:center;
  margin-top:30px;

  .item{
    width:70%;
    margin:0 auto;
    padding:10px 0;
    border-bottom:1px solid #e3e3e3;
    .service-title{
      font-size:22px;
      color:#666;
    }
    .service-link{
      display: flex;
      justify-content: center;
      color:#4A90E2;
      margin-top:4px;
      .icon-chevron-right{
        line-height:20px;
        margin-left:2px;
        font-size:20px;
      }
    }
    &.last{
      border-bottom:0;
    }
  }
}
.slogan{
  margin-top:6px;
  margin-bottom:5px;
  font-size:0.8em;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}

.survey-title{
  font-size:1.1em;
  padding:6px 0 0 20px;
  font-weight:bold;
  margin-bottom:-10px;
}

.full-image{
  margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/new-user-survey.vue